import classNames from 'classnames';
import React from 'react';
import { RegistrationCompleteBlock } from './Components/CompleteBlock/RegistrationCompleteBlock';
import { RegisterForm } from './Components/RegisterForm/RegisterForm';
import { ActiveBlock } from './enum/active-block';
import { useViewModel } from './hook/use-view-model';
import { RegistrBlockProps } from './type/props';

export const RegisterBlock = (props: RegistrBlockProps) => {
  const { activeBlock, registerFormSubmitHandler, phone } = useViewModel();

  if (activeBlock === ActiveBlock.COMPLETE) {
    return <RegistrationCompleteBlock phone={phone} />;
  } else if (activeBlock === ActiveBlock.FORM) {
    return (
      <RegisterForm
        children={props.children}
        className={classNames(props.className)}
        submitHandler={registerFormSubmitHandler}
      />
    );
  }

  return null;
};
